import { Skeleton, Stack } from "@mui/material";

export default function SkeletonsAdminPage() {
  return (
    <Stack sx={{ width: "100%" }} gap={2} mt={2}>
      <Stack
        direction="row"
        gap={2}
        flexWrap={"wrap"}
        justifyContent="space-between"
      >
        {/* Filtros */}
        <Stack direction="row" gap={2} flexWrap={"wrap"} alignItems="center">
          <Skeleton
            variant="rectangular"
            width={300}
            height={50}
            sx={{ borderRadius: "5px" }}
          />
          <Skeleton
            variant="rectangular"
            width={300}
            height={50}
            sx={{ borderRadius: "5px" }}
          />
          <Skeleton
            variant="rectangular"
            width={160}
            height={50}
            sx={{ borderRadius: "5px" }}
          />
          <Skeleton
            variant="rectangular"
            width={160}
            height={50}
            sx={{ borderRadius: "5px" }}
          />
          <Skeleton
            variant="rectangular"
            width={50}
            height={40}
            sx={{ borderRadius: "5px" }}
          />
        </Stack>
        {/*Contadores*/}
        <Stack direction="row" gap={2} alignItems="center">
          <Skeleton
            variant="rectangular"
            width={120}
            height={30}
            sx={{ borderRadius: "16px" }}
          />
          <Skeleton
            variant="rectangular"
            width={120}
            height={30}
            sx={{ borderRadius: "16px" }}
          />
        </Stack>
      </Stack>

      {/* Chip de estado seleccionado */}
      <Skeleton
        variant="rectangular"
        width={200}
        height={30}
        sx={{ borderRadius: "5px" }}
      />
      <Stack direction="column" spacing={2}>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={500}
          sx={{ borderRadius: "5px" }}
        />
      </Stack>
    </Stack>
  );
}
